/* eslint-disable react-hooks/rules-of-hooks */
import Grid from "@mui/material/Grid";
import React, { useCallback, useMemo, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import SidebarLeft from "../../component/ui/chat/SidebarLeft";
import ChatContent from "../../component/ui/chat/ChatContent";

import { useSettings } from "../../@core/hooks/useSettings";

import { useSmartClaim } from "../../hooks/smartClaim";
import { showSnackbar } from "../../component/ui/toast/snackbarService";

import { userData } from "../../hooks/userData";
import Spinner from "../../@core/components/spinner";

const UsedReturn = () => {
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false);
  const [statusTab, setStatusTab] = useState("PENDING");
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [selectedTruesellerAccount, setSelectedTruesellerAccount] = useState("")
  const [selectedId, setSelectedId] = useState("");
  const [isTicketGenerate, setIsTicketGenerate] = useState(false);
  const [isShowFullDate, setIsShowFullDate] = useState(true)

  const sc_claim = useSmartClaim();
  const gstList = userData();

  // ** Hooks
  const theme = useTheme();
  const { settings } = useSettings();

  const hidden = useMediaQuery(theme.breakpoints.down("lg"));

  // ** Vars
  const { skin, chatWidth, smallChatWidth } = settings;
  const lgAbove = useMediaQuery(theme.breakpoints.up("lg"));
  const mdAbove = useMediaQuery(theme.breakpoints.up("md"));

  const sidebarWidth = useMemo(
    () => (lgAbove ? chatWidth : smallChatWidth),
    [chatWidth, lgAbove, smallChatWidth]
  );

  const handleLeftSidebarToggle = () => setLeftSidebarOpen(!leftSidebarOpen);
  const handleUserProfileRightSidebarToggle = () =>
    setUserProfileRightOpen(!userProfileRightOpen);

  const handleSubmit = useCallback(
    (data, selectedCompanyNames, truesellerAccount) => {

      if (statusTab === 'PENDING') {
        data = { ...data, typeOfClaim: "USED", direction: 'ASC', sort: 'createdDate' };
      } else {
        data = { ...data, typeOfClaim: "USED", direction: 'DESC', sort: 'updatedDate' };
      }
      setSelectedCompanyName(selectedCompanyNames);
      setSelectedTruesellerAccount(truesellerAccount)
      setSelectedId(data.gstId);
      sc_claim.getRecordById(data, (response) => {
        if (response.status === "success") {
          showSnackbar("Record Fetch successfully!", "success");
        } else {
          showSnackbar("Something Went Wrong", "error");
        }
        sc_claim.setLoadingById(false)
      });
    },
    [sc_claim]
  );

  useEffect(() => {
    setSelectedCompanyName("");
    setSelectedTruesellerAccount("")
  }, [statusTab]);

  useEffect(() => {
    if (sc_claim.error || gstList.gstError) {
      showSnackbar(sc_claim.error, "error");
    }
  }, [sc_claim.error, gstList.gstError]);

  if (sc_claim.loading || gstList.loading) {
    return <Spinner />;
  }

  return (
    <>
      <Grid container spacing={4} style={{ height: "100%" }}>
        <Grid item xs={12}>
          <Box
            className="app-chat"
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              borderRadius: 1,
              overflow: "hidden",
              position: "relative",
              backgroundColor: "background.paper",
              boxShadow: skin === "bordered" ? 0 : 6,
              ...(skin === "bordered" && {
                border: `1px solid ${theme.palette.divider}`,
              }),
            }}
          >
            <SidebarLeft
              hidden={hidden}
              mdAbove={mdAbove}
              sidebarWidth={sidebarWidth}
              leftSidebarOpen={leftSidebarOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              statusTab={statusTab}
              setStatusTab={setStatusTab}
              count={sc_claim}
              type={"CUSTOMER_RETURN"}
              selectedCompanyName={selectedCompanyName}
              handleChanges={handleSubmit}
              pendingUserList={sc_claim?.scUsedReturnPendingUserList}
              completeUserList={sc_claim?.scUsedReturnCompleteUserList}
              notCompleteUserList={
                sc_claim?.scUsedReturnClaimNotSubmitUserList
              }
              pendingTotalCount={sc_claim?.scUsedReturnPendingCount}
              completeTotalCount={sc_claim?.scUsedReturnCompleteCount}
              notCompleteTotalCount={
                sc_claim?.scUsedReturnClaimNotSubmitCount
              }
              setSelectedCompanyName={setSelectedCompanyName}
              setLoadingById={sc_claim.setLoadingById}
              setIsShowFullDate={setIsShowFullDate}
              isShowFullDate={isShowFullDate}
            />
            <ChatContent
              hidden={hidden}
              mdAbove={mdAbove}
              sidebarWidth={sidebarWidth}
              userProfileRightOpen={userProfileRightOpen}
              handleLeftSidebarToggle={handleLeftSidebarToggle}
              handleUserProfileRightSidebarToggle={
                handleUserProfileRightSidebarToggle
              }
              data={sc_claim.selectedUserData}
              // type={"CUSTOMER_RETURN"}
              type={"USED_RETURN"}
              statusTab={statusTab}
              selectedId={selectedId}
              selectedCompanyName={selectedCompanyName}
              selectedTruesellerAccount={selectedTruesellerAccount}
              handleChanges={handleSubmit}
              downloadData={[
                "reverseWaybill",
                "barcodeImage",
                "productImage",
                "unpackingVideo",
                'attachment'
              ]}
              isLoading={sc_claim.loadingById}
              heading={'I have received used product as return'}
              isTicketGenerate={isTicketGenerate}
              setLoadingById={sc_claim.setLoadingById}
              setIsShowFullDate={setIsShowFullDate}
              isShowFullDate={isShowFullDate}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default UsedReturn;
